function avautuvaSisaltoObservePanelChanges(panel) {

    if (panel.dataset.observing === "true") {
        return;
    }

    panel.dataset.observing = "true";

    function updateHeight() {

        // Don't interfere while opening or closing
        if (
            !panel.classList.contains("active") ||
            panel.dataset.animating === "true"
        ) {
            return;
        }

        panel.style.height = "auto";

        var newHeight = panel.scrollHeight + "px";

        panel.style.height = newHeight;
    }

    var resizeObserver = new ResizeObserver(function () {
        updateHeight();
    });

    resizeObserver.observe(panel);

    var mutationObserver = new MutationObserver(function () {
        updateHeight();
    });

    mutationObserver.observe(panel, {
        childList: true,
        subtree: true,
        characterData: true
    });
}


function avautuvaSisaltoToggle(header) {

    var panel = header.nextElementSibling;

    if (!panel) {
        return;
    }

    var plusicon = header.querySelector(".showmore");
    var minusicon = header.querySelector(".showless");


    // OPEN
    if (!panel.classList.contains("active")) {

        header.setAttribute("aria-expanded", "true");

        if (plusicon) {
            plusicon.classList.remove("show");
            plusicon.classList.add("hidden");
        }

        if (minusicon) {
            minusicon.classList.remove("hidden");
            minusicon.classList.add("show");
        }

        // Prevent observers from interfering with animation
        panel.dataset.animating = "true";

        // Make panel visible
        panel.classList.add("active");

        // Get natural height
        panel.style.height = "auto";

        var height = panel.scrollHeight + "px";

        // Start at 0
        panel.style.height = "0px";

        // Force browser reflow
        void panel.offsetHeight;

        // Start animation
        panel.style.height = height;

        panel.addEventListener("transitionend", function (e) {

            if (e.propertyName !== "height") {
                return;
            }

            // Animation finished
            panel.dataset.animating = "false";

            // Let ResizeObserver handle future changes
            panel.style.height = panel.scrollHeight + "px";

        }, {
            once: true
        });

        // Start observing
        avautuvaSisaltoObservePanelChanges(panel);


    // CLOSE
    } else {

        header.setAttribute("aria-expanded", "false");

        if (plusicon) {
            plusicon.classList.remove("hidden");
            plusicon.classList.add("show");
        }

        if (minusicon) {
            minusicon.classList.remove("show");
            minusicon.classList.add("hidden");
        }

        panel.dataset.animating = "true";

        // Current height
        panel.style.height = panel.scrollHeight + "px";

        // Force reflow
        void panel.offsetHeight;

        // Animate to zero
        panel.style.height = "0px";

        panel.addEventListener("transitionend", function (e) {

            if (e.propertyName !== "height") {
                return;
            }

            panel.classList.remove("active");

            panel.dataset.animating = "false";

        }, {
            once: true
        });
    }
}


document.addEventListener("click", function (e) {

    var header = e.target.closest(".avautuvasisalto__header");

    if (header) {
        avautuvaSisaltoToggle(header);
    }
});


document.addEventListener("keyup", function (e) {

    var header = e.target.closest(".avautuvasisalto__header");

    if (
        header &&
        (e.key === "Enter" || e.key === " ")
    ) {
        e.preventDefault();

        avautuvaSisaltoToggle(header);
    }
});


if (window.location.hash) {

    var targetId = window.location.hash.substring(1);
    var targetElement = document.getElementById(targetId);

    if (
        targetElement &&
        targetElement.classList.contains("avautuvasisalto")
    ) {

        var headerWithinTarget =
            targetElement.querySelector(".avautuvasisalto__header");

        if (headerWithinTarget) {

            // Add a delay of 500 milliseconds (adjust as needed)
            setTimeout(function () {

                // If the target element exists and trigger the toggle function using the header element found within it
                avautuvaSisaltoToggle(headerWithinTarget);

                // Remove the anchor from the URL
                window.history.replaceState(
                    null,
                    null,
                    window.location.pathname + window.location.search
                );

            }, 1000);
        }
    }
}
